import * as e from "react";
const t = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement("g", { clipPath: "url(#thermostat-full_svg__clip0)", fill: "#2d6ded" }, /* @__PURE__ */ e.createElement("path", { d: "M12 0a5 5 0 015 5v7.1a7 7 0 11-10 0V5a5 5 0 015-5zm0 2a3 3 0 00-3 3v7.92l-.57.58a5 5 0 107.14 0l-.57-.58V5a3 3 0 00-3-3zm0 7a1 1 0 011 1v4.17a3 3 0 11-2 0V10a1 1 0 011-1z" }), /* @__PURE__ */ e.createElement("path", { d: "M12 0a5 5 0 015 5v7.1a7 7 0 11-10 0V5a5 5 0 015-5zm0 2a3 3 0 00-3 3v7.92l-.57.58a5 5 0 107.14 0l-.57-.58V5a3 3 0 00-3-3zm0 2a1 1 0 011 1v9.17a3 3 0 11-2 0V5a1 1 0 011-1z" })),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "thermostat-full_svg__clip0" }, /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" })))
), l = t;
export {
  l as default
};
